import { render, staticRenderFns } from "./EditCustomDocEmployeeSignature.vue?vue&type=template&id=643e3c44&scoped=true&"
import script from "./EditCustomDocEmployeeSignature.vue?vue&type=script&lang=js&"
export * from "./EditCustomDocEmployeeSignature.vue?vue&type=script&lang=js&"
import style0 from "./EditCustomDocEmployeeSignature.vue?vue&type=style&index=0&id=643e3c44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643e3c44",
  null
  
)

export default component.exports